import {
  MarketsByRegionType,
  ProductConfigType,
  SourceConfigType,
  SystemConfigType,
} from '../../../types/administrationTypes';

export const defaultMarketsByRegion: MarketsByRegionType = {
  GAS: [
    {
      selected: false,
      name: 'Germany/Austria/Switzerland',
      value: 'M_GAS',
    },
  ],
  BeNe: [
    {
      selected: false,
      name: 'Belgium/Netherlands',
      value: 'M_BENE',
    },
  ],
  'UK / I': [
    {
      selected: false,
      name: 'United Kingdom',
      value: 'M_UK',
    },
    {
      selected: false,
      name: 'Ireland',
      value: 'M_IE',
    },
  ],
  Nordics: [
    {
      selected: false,
      name: 'Norway',
      value: 'M_NO',
    },
    {
      selected: false,
      name: 'Sweden',
      value: 'M_SE',
    },
    {
      selected: false,
      name: 'Finland',
      value: 'M_FI',
    },
    {
      selected: false,
      name: 'Denmark',
      value: 'M_DK',
    },
  ],
};

export const defaultProducts: ProductConfigType[] = [
  {
    selected: false,
    disabled: true,
    name: 'tui.com/flug',
    value: 'P_tui.com/flug',
    belongsTo: ['M_GAS'],
  },
  { selected: false, disabled: true, name: 'Fly and Mix', value: 'P_FlyandMix', belongsTo: ['M_GAS'] },
  { selected: false, disabled: true, name: 'X-TUI', value: 'P_X-TUI', belongsTo: ['M_GAS'] },
  {
    selected: false,
    disabled: true,
    name: 'TUI Ticket Shop',
    value: 'P_TuiTicketShop',
    belongsTo: ['M_BENE', 'M_GAS'],
  },
  {
    selected: false,
    disabled: true,
    name: 'TRIPS Flight Only',
    value: 'P_TripsFlightOnly',
    belongsTo: ['M_BENE'],
  },
  {
    selected: false,
    disabled: true,
    name: 'TRIPS Package',
    value: 'P_TripsPackage',
    belongsTo: ['M_GAS'],
  },
  { selected: false, disabled: true, name: 'Sparflug', value: 'P_Sparflug', belongsTo: ['M_GAS'] },
];

export const defaultSources: SourceConfigType[] = [
  {
    selected: false,
    name: 'NSK',
    value: 'S_NSK',
  },
  {
    selected: false,
    name: 'NDC',
    value: 'S_NDC',
  },
];

export const defaultSystems: SystemConfigType[] = [
  {
    selected: false,
    name: 'Dev',
    value: 'SY_DEV',
  },
  {
    selected: false,
    name: 'Qa',
    value: 'SY_QA',
  },
  {
    selected: false,
    name: 'Prod',
    value: 'SY_PROD',
  },
];
